
function ViewAnalysis() {
  return (
    <div>
        <p>
          Анализ прошлых тренировок
        </p>
    </div>
  );
}

export default ViewAnalysis;
